import { render, staticRenderFns } from "./transfer-protocol-modal-factory.vue?vue&type=template&id=0e754151&scoped=true"
import script from "./transfer-protocol-modal-factory.vue?vue&type=script&lang=js"
export * from "./transfer-protocol-modal-factory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e754151",
  null
  
)

export default component.exports